<template>
    <div class="admin no-save" @contextmenu.prevent>
        <div v-if="!isLoggedIn">
            <h1>Login</h1>
            <form @submit.prevent="handleLogin">
                <label for="username">Benutzername:</label>
                <input id="username" v-model="username" required placeholder="Benutzername" />
                <label for="password">Passwort:</label>
                <input type="password" id="password" v-model="password" required placeholder="Passwort" />
                <button type="submit">Einloggen</button>
            </form>
            <p v-if="loginError" class="error">Login fehlgeschlagen.</p>
        </div>

        <div v-else>
            <div class="topbar">
                <h1>Bilder verwalten</h1>
                <button class="logout" @click="logout">Logout</button>
            </div>

            <div class="category" v-for="category in categorys" :key="category" @dragover.prevent
                @drop="handleDrop(category)">
                <p class="category-name">{{ category }}</p>

                <div v-for="image in getImagesByCategory(category)" :key="image.id" class="list-item" draggable="true"
                    @dragstart="handleDragStart(image)">
                    <div class="drag-icon">☰</div>
                    <p class="image-id">#{{ image.id }}</p>
                    <img :src="`/uploads/${image.filename}`" :alt="image.description" class="image-preview"
                        draggable="false" @contextmenu.prevent />
                    <p class="description">{{ image.description }}</p>
                    <div class="actions">
                        <img src="../assets/img/edit.png" alt="edit" class="action-icon" @click="openEditMenu(image)" />
                        <img src="../assets/img/delete.png" alt="delete" class="action-icon"
                            @click="deleteImage(image.id)" />
                    </div>
                </div>
            </div>

            <div v-if="editMenuVisible" class="edit-menu" @click.self="closeEditMenuWithoutSaving">
                <div class="edit-menu-content">
                    <button class="close-x" @click="closeEditMenuWithoutSaving">&times;</button>
                    <img :src="`/uploads/${selectedImage.filename}`" :alt="selectedImage.description"
                        class="edit-menu-image" draggable="false" @contextmenu.prevent />
                    <div class="edit-menu-input">
                        <label for="description">Beschreibung:</label>
                        <input type="text" id="description" v-model="selectedImage.description" />
                    </div>
                    <div class="edit-menu-input">
                        <label for="category">Kategorie:</label>
                        <select id="category" v-model="selectedImage.category">
                            <option v-for="c in categorys" :key="c" :value="c">{{ c }}</option>
                        </select>
                    </div>
                    <button @click="closeEditMenu" class="close-button">Speichern</button>
                </div>
            </div>

            <div v-if="addMenuVisible" class="add-menu" @click.self="closeAddMenu">
                <div class="add-menu-content">
                    <button class="close-x" @click="closeAddMenu">&times;</button>
                    <h2>Neues Bild hinzufügen</h2>
                    <form @submit.prevent="addImage">
                        <input type="file" @change="handleFileChange" required />
                        <input type="text" v-model="newImageDescription" placeholder="Beschreibung" required />
                        <select v-model="newImageCategory" required>
                            <option v-for="category in categorys" :key="category" :value="category">{{ category }}
                            </option>
                        </select>
                        <button type="submit" class="upload-button">Hochladen</button>
                    </form>
                </div>
            </div>

            <button @click="saveChanges" class="save-button">Änderungen speichern</button>
            <div class="add-image-button" @click="openAddMenu">+</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            categorys: ["Landschaft", "Gebäude", "Blumen", "Berge", "Tiere", "Menschen", "Pilze"],
            images: [],
            draggedImage: null,
            editMenuVisible: false,
            addMenuVisible: false,
            selectedImage: null,
            newImageFile: null,
            newImageDescription: "",
            newImageCategory: "",
            isLoggedIn: false,
            username: "",
            password: "",
            loginError: false,
            modifiedIds: []
        }
    },
    methods: {
        async handleLogin() {
            this.loginError = false
            try {
                const res = await fetch("/api/auth-login.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ username: this.username, password: this.password })
                })
                if (!res.ok) { this.loginError = true; return }
                this.isLoggedIn = true
                this.username = ""
                this.password = ""
                await this.fetchImages()
            } catch (e) { this.loginError = true; console.error(e) }
        },
        async logout() {
            try {
                await fetch("/api/auth-logout.php", { method: "POST", credentials: "include" })
                this.isLoggedIn = false
                this.images = []
            } catch (e) { console.error(e) }
        },
        async fetchImages() {
            try {
                const response = await fetch("/api/images.php?limit=100&offset=0", { credentials: "include" })
                if (!response.ok) return

                const payload = await response.json()
                const data = payload && payload.data ? payload.data : payload

                this.images = Array.isArray(data) ? data : (data.items || [])
            } catch (error) {
                console.error("Fehler beim Abrufen der Bilder:", error)
                this.images = []
            }
        },
        getImagesByCategory(category) {
            return Array.isArray(this.images) ? this.images.filter(image => image.category === category) : []
        },
        handleDragStart(image) { this.draggedImage = image },
        async handleDrop(category) {
            if (this.draggedImage) {
                this.draggedImage.category = category
                if (!this.modifiedIds.includes(this.draggedImage.id)) this.modifiedIds.push(this.draggedImage.id)
                this.draggedImage = null
            }
        },
        openEditMenu(image) { this.selectedImage = { ...image }; this.editMenuVisible = true },
        closeEditMenuWithoutSaving() { this.editMenuVisible = false; this.selectedImage = null },
        async closeEditMenu() {
            const index = this.images.findIndex((img) => img.id === this.selectedImage.id)
            if (index !== -1) {
                this.images[index] = { ...this.selectedImage }
                await this.updateImage(this.selectedImage.id, { description: this.selectedImage.description, category: this.selectedImage.category })
            }
            this.editMenuVisible = false
        },
        openAddMenu() { this.addMenuVisible = true },
        closeAddMenu() { this.addMenuVisible = false; this.newImageFile = null; this.newImageDescription = ""; this.newImageCategory = "" },
        handleFileChange(event) { this.newImageFile = event.target.files[0] },
        async addImage() {
            if (!this.newImageFile || !this.newImageDescription || !this.newImageCategory) { alert("Bitte alle Felder ausfüllen."); return }
            const formData = new FormData()
            formData.append("file", this.newImageFile)
            formData.append("description", this.newImageDescription)
            formData.append("category", this.newImageCategory)
            try {
                const response = await fetch("/api/upload.php", { method: "POST", body: formData, credentials: "include" })
                if (response.ok) {
                    const created = await response.json()
                    this.images.unshift(created)
                    this.closeAddMenu()
                    alert("Bild erfolgreich hochgeladen!")
                } else { alert("Fehler beim Hochladen des Bildes.") }
            } catch (e) { console.error(e); alert("Fehler beim Hochladen des Bildes.") }
        },
        async updateImage(id, payload) {
            try {
                const res = await fetch(`/api/images.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify([{ id, description: payload.description, category: payload.category }])
                })
                if (!res.ok) alert("Fehler beim Speichern.")
            } catch (e) { console.error(e); alert("Fehler beim Speichern.") }
        },
        async saveChanges() {
            const toUpdate = this.images.filter(i => this.modifiedIds.includes(i.id))
            try {
                const res = await fetch(`/api/images.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify(toUpdate.map(img => ({ id: img.id, description: img.description, category: img.category })))
                })
                if (!res.ok) throw new Error()
                this.modifiedIds = []
                alert("Änderungen erfolgreich gespeichert!")
            } catch (e) { console.error(e); alert("Fehler beim Speichern.") }
        },
        async deleteImage(imageId) {
            try {
                const params = new URLSearchParams(); params.set('id', String(imageId))
                const response = await fetch(`/api/images.php`, {
                    method: "DELETE",
                    credentials: "include",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: params.toString()
                })
                if (response.ok) {
                    this.images = this.images.filter((image) => image.id !== imageId)
                    alert("Bild erfolgreich gelöscht.")
                } else { alert("Fehler beim Löschen des Bildes.") }
            } catch (e) { console.error(e); alert("Fehler beim Löschen des Bildes.") }
        }
    },
    async mounted() {
        try {
            const r = await fetch('/api/auth-me.php', { credentials: 'include' })
            const me = await r.json()
            if (me.ok) {
                this.isLoggedIn = true
                await this.fetchImages()
            }
        } catch (e) {
            console.error(e)
        }
    }
}
</script>

<style scoped>
/* Nur bei Bildern Drag/Select verhindern */
.no-save img,
.no-save .edit-menu-image {
    -webkit-user-drag: none;
    user-select: none;
}

form {
    background-color: #1e1e1e;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
    width: 100%;
    max-width: 400px;
    margin: auto;
}

form label {
    color: #fff;
    font-size: 1rem;
    margin-bottom: 0.5rem;
    display: block;
}

form input {
    width: calc(100% - 0.8rem * 2);
    padding: 0.8rem;
    margin-bottom: 1rem;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    text-align: center;
}

form button {
    width: 100%;
    padding: 0.8rem;
    background-color: #00aeff;
    color: #fff;
    font-size: 1rem;
    font-weight: bold;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

form button:hover {
    background-color: #007ecc;
}

form .error {
    color: #ff5555;
    font-size: 0.9rem;
    margin-top: 1rem;
    text-align: center;
}

.topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2vh;
}

.logout {
    padding: .8rem 1rem;
    background: #333;
    color: #fff;
    border: none;
    border-radius: .5rem;
    cursor: pointer;
}

.admin {
    background-color: black;
    color: white;
    min-height: 40vh;
    padding: 2vh;
    font-family: "SamsungSans-Regular";
}

h1 {
    margin: 0;
    padding: 4vh;
    text-align: center;
}

.category {
    width: 100%;
    background-color: rgb(16, 16, 16);
    margin-bottom: 2vh;
    border-radius: 1vh;
    padding: 1vh;
}

.category .category-name {
    margin: 0;
    padding: 1vh 0;
    font-size: 2vh;
    font-weight: bold;
}

.category .list-item {
    display: flex;
    align-items: center;
    background-color: rgb(25, 25, 25);
    padding: 1.5vh 1vh;
    border-radius: 1vh;
    margin-bottom: 1vh;
}

.category .list-item:nth-child(even) {
    background-color: rgb(31, 31, 31);
}

.category .list-item .drag-icon {
    font-size: 3vh;
    padding: 1vh 2vh 1vh 2vh;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
}

.category .list-item img.image-preview {
    height: 5vh;
    width: 8vh;
    border-radius: 0.5vh;
    margin-right: 2vh;
    object-fit: cover;
    object-position: center;
}

.category .list-item .description {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 2vh;
    text-align: left;
}

.category .list-item .image-id {
    font-size: 1.75vh;
    padding-right: 2.5vh;
}

.category .list-item .actions {
    display: flex;
    padding-right: 2vh;
    gap: 1vh;
}

.category .list-item .actions .action-icon {
    width: 2vh;
    height: 2vh;
    cursor: pointer;
    transition: .2s;
}

.category .list-item .actions .action-icon:hover {
    opacity: 60%;
}

.save-button {
    display: block;
    margin: 3vh auto;
    padding: 1vh 2vh;
    background-color: #00aeff;
    color: white;
    border: none;
    border-radius: 1vh;
    cursor: pointer;
    font-size: 1.5vh;
    transition: .2s;
}

.save-button:hover {
    background-color: #0056b3;
}

.edit-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
}

.edit-menu-content {
    background-color: rgb(16, 16, 16);
    padding: 4vh;
    border-radius: 1vh;
    text-align: center;
    width: 40vh;
    position: relative;
}

.edit-menu-image {
    max-width: 100%;
    height: 20vh;
    margin-bottom: 3vh;
    object-fit: contain;
    border-radius: 0.5vh;
}

.edit-menu-input {
    margin-bottom: 3vh;
}

.edit-menu-input label {
    color: white;
    font-size: 2vh;
    margin-bottom: 1vh;
    display: block;
}

.edit-menu-input input,
.edit-menu-input select {
    width: calc(100% - 2vh);
    padding: 1vh;
    border-radius: 0.5vh;
    border: 0.1vh solid #ccc;
    font-size: 1.5vh;
}

.close-button {
    padding: 1vh 2vh;
    background-color: #00aeff;
    color: white;
    border: none;
    border-radius: 0.5vh;
    cursor: pointer;
    font-size: 1.5vh;
}

.close-button:hover {
    background-color: #0056b3;
}

.add-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.add-menu-content {
    background-color: rgb(16, 16, 16);
    padding: 4vh;
    border-radius: 1vh;
    text-align: center;
    width: 40vh;
    position: relative;
}

.add-menu-content h2 {
    color: white;
    margin-bottom: 3vh;
}

.add-menu-content input,
.add-menu-content select {
    display: block;
    width: calc(100% - 4vh);
    margin: 1.5vh auto;
    padding: 1vh;
    border: 0.1vh solid #ccc;
    border-radius: 0.5vh;
    font-size: 1.5vh;
}

.upload-button {
    padding: 1vh 2vh;
    background-color: #00aeff;
    color: white;
    border: none;
    border-radius: 0.5vh;
    cursor: pointer;
    font-size: 1.5vh;
    transition: .2s;
}

.upload-button:hover {
    background-color: #0056b3;
}

.close-x {
    position: absolute;
    top: 1vh;
    right: 1vh;
    background: none;
    border: none;
    color: white;
    font-size: 2.5vh;
    cursor: pointer;
}

.close-x:hover {
    color: #ff5555;
}

.add-image-button {
    position: fixed;
    bottom: 2vh;
    right: 2vh;
    background-color: #00aeff;
    color: white;
    width: 5vh;
    height: 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 3vh;
    cursor: pointer;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.add-image-button:hover {
    background-color: #0056b3;
}
</style>
